import React from 'react'

import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { Box, Button } from '@material-ui/core'

import { MenuButton, Permitted } from 'components'

import { routes } from 'Routes'
import constants from 'constants/index'

const ActionButtons = ({ changesManagement }) => {
  const history = useHistory()

  const redirectToEdit = () =>
    history.push(
      reverse(routes.changesManagement.edit, {
        changesManagementId: changesManagement?.id,
      }),
    )

  const redirectToShow = () =>
    history.push(
      reverse(routes.changesManagement.show, {
        changesManagementId: changesManagement?.id,
      }),
    )

  return (
    <Box display="flex" justifyContent="flex-end">
      <MenuButton>
        <Button color="secondary" fullWidth onClick={redirectToShow}>
          Visualizar
        </Button>
        {changesManagement?.status !==
          constants.changesManagement.FINALIZED_STATUS_LABEL && (
          <Permitted tag={constants.permissions.CHANGES_MANAGEMENT.MANAGE}>
            <Button color="secondary" fullWidth onClick={redirectToEdit}>
              Editar
            </Button>
          </Permitted>
        )}
      </MenuButton>
    </Box>
  )
}

export default ActionButtons
